import { useMemo } from 'react';

export const useShowClearBtnOption = () => {
  const showClearBtnOption = useMemo(() => {
    return { showClearButton: true };
  }, []);

  return showClearBtnOption;
};
